import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { Observable } from "rxjs";
import { IRound } from "../interfaces";
import { RoundRepository } from "../round.repository";
import { map } from "rxjs/operators";
import { IUserBet } from "../store/interfaces";

@Injectable()
export class GetUserBetsUseCase implements IUseCase<void, Observable<IUserBet[]>> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(): Observable<IUserBet[]> {
        return this.roundRepository.get().pipe(map((round: IRound) => round.userBets));
    }
}
